import { Component, Input } from "@angular/core";
import { User, Comment, Discussion, PanelMember } from "../../../../models";

@Component({
  selector: "edit-comment-button",
  templateUrl: "./edit-comment-button.component.html",
  styleUrls: [
    "./edit-comment-button.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class EditCommentButtonComponent {
  @Input() currentUser: User;
  @Input() discussion: Discussion;
  @Input() commentToEdit: Comment;
  @Input() currentPanelMember: PanelMember;

  constructor() {}
}
